<div
    class="d-flex w-100 comp-bonus-widget"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="cmps-scorecard-widget--cmps-container"
        [collapsable]="false"
        variant="colored"
    >
        <cmps-container-header
            class="text-center"
            [headerColour]="headerColour"
            [textColour]="headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content [backgroundColour]="backgroundColour">
            <cmps-wait-status
                [srStatus]="'Loading ' + _widget.name"
                *ngIf="_isLoadingData | async"
            ></cmps-wait-status>
            <div *ngIf="!(_isLoadingData | async) && !_data?.compensationBonus">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100 h-100 d-flex"
                *ngIf="!(_isLoadingData | async) && _data?.compensationBonus"
            >
                <div
                    class="comp-bonus-widget--col"
                    *ngIf="_data?.compensationBonus?.bonusModifier"
                >
                    <div
                        class="d-flex align-items-center justify-content-center pt-1 pb-1 comp-bonus-widget--col-title"
                    >
                        {{ _i18n._9306_BASE_BONUS | translate }}
                    </div>
                    <div
                        class="d-flex align-items-center justify-content-center pt-1 pb-1 comp-bonus-widget--col-value"
                        [style.color]="textColour"
                    >
                        {{
                            _data?.compensationBonus?.bonusBaseAmount
                                | number: '1.0-2' || '-'
                        }}
                    </div>
                </div>
                <div
                    class="comp-bonus-widget--col"
                    *ngIf="_data?.compensationBonus?.bonusModifier"
                >
                    <div
                        class="d-flex align-items-center justify-content-center pt-1 pb-1 comp-bonus-widget--col-title"
                    >
                        {{ _i18n._9307_MODIFIERS | translate }}
                    </div>
                    <div
                        class="d-flex align-items-center justify-content-center pt-1 pb-1 comp-bonus-widget--col-value"
                        [style.color]="textColour"
                    >
                        {{ _data?.compensationBonus?.operation
                        }}{{
                            _data?.compensationBonus?.bonusModifier
                                | percent: '1.0-2'
                        }}
                    </div>
                </div>
                <div class="comp-bonus-widget--col">
                    <div
                        class="d-flex align-items-center pt-1 pb-1 comp-bonus-widget--col-title"
                    >
                        <div class="comp-bonus-widget--col-title-lbl">
                            {{ _i18n._9308_ESTIMATED_PAYOUT | translate }}
                        </div>
                        <div class="comp-bonus-widget--col-title-icon">
                            <button
                                class="cmps-icon-button--no-bg"
                                cmpsIconButton
                                (click)="_onBonusDetailClick($event)"
                            >
                                <cmps-icon
                                    [style.fill]="_widget.containerColour"
                                    svgIcon="help-circle-outline"
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>
                    <div
                        class="d-flex align-items-center justify-content-center pt-1 pb-1 comp-bonus-widget--col-value"
                        [style.color]="textColour"
                    >
                        {{
                            _data?.compensationBonus?.bonusAmount
                                | number: '1.0-2'
                        }}
                    </div>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
